import { careerProfileLabels } from "../../../Types/careerProfileLabels"
import PlansForSchoolAndTrainingCheckboxForm from "./PlansForSchoolAndTrainingChecboxForm"
import EditorField from "../../../Utils/EditorField"
import RadioButtonField from "../../../Utils/RadioButtonField"
import TextField from "../../../Utils/TextField"

const PlansForSchoolAndTraining = ({ formik }) => {
  return (
    <>
      <PlansForSchoolAndTrainingCheckboxForm
        label={
          careerProfileLabels.plansForSchoolAndTraining.plansForSchool_1.label
        }
        setValue={formik.setFieldValue}
        value={formik.values.plansForSchool_1}
        valueName={
          careerProfileLabels.plansForSchoolAndTraining.plansForSchool_1.value
        }
        callback={(value) => {
          if (!value?.other) {
            formik.setFieldValue(
              careerProfileLabels.plansForSchoolAndTraining.plansForSchool_1a
                .value,
              ""
            )
          }
        }}
      />
      {formik.values.plansForSchool_1.other && (
        <div style={{ marginBottom: "15px" }}>
          <TextField
            label={
              careerProfileLabels.plansForSchoolAndTraining.plansForSchool_1a
                .label
            }
            setValue={formik.setFieldValue}
            size={50}
            value={formik.values.plansForSchool_1a}
            valueName={
              careerProfileLabels.plansForSchoolAndTraining.plansForSchool_1a
                .value
            }
          />
        </div>
      )}
      <EditorField
        value={formik.values.plansForSchool_2}
        onTextChange={formik.setFieldValue}
        valueName={
          careerProfileLabels.plansForSchoolAndTraining.plansForSchool_2.value
        }
        label={
          careerProfileLabels.plansForSchoolAndTraining.plansForSchool_2.label
        }
      />
      <EditorField
        value={formik.values.plansForSchool_3}
        onTextChange={formik.setFieldValue}
        valueName={
          careerProfileLabels.plansForSchoolAndTraining.plansForSchool_3.value
        }
        label={
          careerProfileLabels.plansForSchoolAndTraining.plansForSchool_3.label
        }
      />
      <RadioButtonField
        label={
          careerProfileLabels.plansForSchoolAndTraining.plansForSchool_4.label
        }
        setValue={formik.setFieldValue}
        valueName={
          careerProfileLabels.plansForSchoolAndTraining.plansForSchool_4.value
        }
        value={formik.values.plansForSchool_4}
        callback={() => {
          if (formik.values.plansForSchool_4 !== "Yes") {
            formik.setFieldValue(
              careerProfileLabels.plansForSchoolAndTraining.plansForSchool_4a
                .value,
              ""
            )
            formik.setFieldValue(
              careerProfileLabels.plansForSchoolAndTraining.plansForSchool_4b
                .value,
              ""
            )
          }
        }}
      />
      {formik.values.plansForSchool_4 === "Yes" && (
        <>
          <EditorField
            value={formik.values.plansForSchool_4a}
            onTextChange={formik.setFieldValue}
            valueName={
              careerProfileLabels.plansForSchoolAndTraining.plansForSchool_4a
                .value
            }
            label={
              careerProfileLabels.plansForSchoolAndTraining.plansForSchool_4a
                .label
            }
          />
          <RadioButtonField
            label={
              careerProfileLabels.plansForSchoolAndTraining.plansForSchool_4b
                .label
            }
            setValue={formik.setFieldValue}
            valueName={
              careerProfileLabels.plansForSchoolAndTraining.plansForSchool_4b
                .value
            }
            value={formik.values.plansForSchool_4b}
          />
        </>
      )}
      <EditorField
        value={formik.values.plansForSchool_5}
        onTextChange={formik.setFieldValue}
        valueName={
          careerProfileLabels.plansForSchoolAndTraining.plansForSchool_5.value
        }
        label={
          careerProfileLabels.plansForSchoolAndTraining.plansForSchool_5.label
        }
      />
      <EditorField
        value={formik.values.plansForSchool_6}
        onTextChange={formik.setFieldValue}
        valueName={
          careerProfileLabels.plansForSchoolAndTraining.plansForSchool_6.value
        }
        label={
          careerProfileLabels.plansForSchoolAndTraining.plansForSchool_6.label
        }
      />
    </>
  )
}
export default PlansForSchoolAndTraining
